import { render, staticRenderFns } from "./company_detail.vue?vue&type=template&id=c270c4aa&scoped=true&"
import script from "./company_detail.vue?vue&type=script&lang=js&"
export * from "./company_detail.vue?vue&type=script&lang=js&"
import style0 from "./company_detail.vue?vue&type=style&index=0&id=c270c4aa&scoped=true&lang=css&"
import style1 from "./company_detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c270c4aa",
  null
  
)

export default component.exports